export default __webpack_public_path__ + "static/cloth.header-dc1648d63bdb8f1d29c9704b3a1bae0c.jpg";